import React from 'react'

function BrandOne() {
    return (
        <div>
            {/* start trusted client section */}
            <div className="rts-trusted-client rts-section-gapBottom">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="title-area-client text-center">
                                <p className="client-title">Our Trusted Clients</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="client-wrapper-one">
                            <a href="#">
                                <img src="assets/images/client/01.png" alt="business_LDR Groups" />
                            </a>
                            <a href="#">
                                <img src="assets/images/client/02.png" alt="business_LDR Groups" />
                            </a>
                            <a href="#">
                                <img src="assets/images/client/03.png" alt="business_LDR Groups" />
                            </a>
                            <a href="#">
                                <img src="assets/images/client/04.png" alt="business_LDR Groups" />
                            </a>
                            <a href="#">
                                <img src="assets/images/client/05.png" alt="business_LDR Groups" />
                            </a>
                            <a href="#">
                                <img src="assets/images/client/06.png" alt="business_LDR Groups" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {/* end trusted client section */}

        </div>
    )
}

export default BrandOne